const normalizeBaseUrl = (value?: string) => value?.replace(/\/+$/, "") || ""

export const getFunctionsBaseUrl = () => {
  const explicit = normalizeBaseUrl(import.meta.env.VITE_SUPABASE_FUNCTIONS_URL)
  if (explicit) return explicit

  const supabaseUrl = normalizeBaseUrl(import.meta.env.VITE_SUPABASE_URL)
  return `${supabaseUrl}/functions/v1`
}
